module.exports = __webpack_public_path__ + "img/2193.png";